import { render } from "./StarredPage.vue?vue&type=template&id=19b699cd&ts=true"
import script from "./StarredPage.vue?vue&type=script&lang=ts"
export * from "./StarredPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__